import { render } from "./hero.vue?vue&type=template&id=b6a9bf1e&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=b6a9bf1e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b6a9bf1e"

export default script